export default __webpack_public_path__ + "static/media/Quick_Start.d9b495ef.pdf";